import PropTypes from 'prop-types';
import React from 'react';
import axios from 'axios';
import { includes } from 'lodash';
import { isLoggedIn, getAccount, getAuthHeader } from '../../helpers/securityHelper';
import LocalStorage from '../../helpers/storage/LocalStorage';
import Button from './Button/Button';
import { IconFavoriteBorder } from '../../components/sharedComponents/icons/Icons';

class FavoriteHeart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            liked: false,
            loggedIn: false
        };

        this.addToFavorites = this.addToFavorites.bind(this);
        this.removeFromFavorites = this.removeFromFavorites.bind(this);
        this.toggleHeart = this.toggleHeart.bind(this);
        this.isLocationFavorite = this.isLocationFavorite.bind(this);
    }

    componentDidMount() {
        const loggedIn = isLoggedIn();
        const liked = this.isLocationFavorite(this.props.id);

        this.setState({
            loggedIn,
            liked
        });
    }

    componentDidUpdate(prevProps) {
        const { id } = this.props;

        if (this.state.loggedIn && prevProps.id && prevProps.id !== id) {
            const liked = this.isLocationFavorite(id);
            this.setState({
                liked
            });
        }
    }

    setLocalStorageAccount(account) {
        LocalStorage.setItem('recaccount', JSON.stringify(account));
    }

    isLocationFavorite(id) {
        let liked = false;
        const account = getAccount();
        liked = includes(account.favorites, id);
        return liked;
    }

    addToFavorites() {
        const url = '/api/accounts/favorites';
        const data = {
            id: this.props.id
        };
        axios.post(url, data, { headers: { Authorization: getAuthHeader() } }).then((response) => {
            this.setLocalStorageAccount(response.data);
            this.setState({
                liked: true
            });
        })
            .catch(() => {
                // TODO what happens when there is an error?
                this.setState({
                    liked: false
                });
            });
    }

    removeFromFavorites() {
        const url = `/api/accounts/favorites/${this.props.id}`;
        axios.delete(url, { headers: { Authorization: getAuthHeader() } }).then((response) => {
            this.setLocalStorageAccount(response.data);
            this.setState({
                liked: false
            });
        })
            .catch(() => {
                // TODO what happens when there is an error?
                this.setState({
                    liked: true
                });
            });
    }

    toggleHeart = (e) => {
        e.preventDefault();
        if (this.state.liked) {
            this.removeFromFavorites();
        }
        else {
            this.addToFavorites();
        }
    }

    render() {
        const { showFavoriteText } = this.props;

        let heartClass = 'rec-favorite-heart-unliked';
        if (this.state.liked) {
            heartClass = 'rec-favorite-heart-liked';
        }
        if (this.state.loggedIn) {
            return (
                <div className="rec-favorite-heart-wrapper">
                    <Button
                        appearance="subtle"
                        size="lg"
                        className={`rec-favorite-heart ${heartClass} p-0`}
                        iconBeforeElement={<IconFavoriteBorder />}
                        screenReaderTextBefore={this.state.liked ? 'Selected as a favorite. Press to remove from favorites.' : 'Not selected as a favorite. Press to add to favorites.'}
                        onClick={this.toggleHeart}>
                        {showFavoriteText ? <span className="rec-favorite-text">Favorite</span> : null}
                    </Button>
                </div>
            );
        }
        return null;
    }
}

FavoriteHeart.propTypes = {
    id: PropTypes.string,
    showFavoriteText: PropTypes.bool
};

export default FavoriteHeart;
